import { Routes } from '@angular/router';
import { HomeComponent } from './home/home.component';

export const routes: Routes = [
  {
    path: 'home',
    component: HomeComponent
  },
  {
    path: 'about-us',
    loadComponent: () => import('./about-us/about-us.component').then(m => m.AboutUsComponent)
  },
  {
    path: 'training',
    loadComponent: () => import('./training/training.component').then(m => m.TrainingComponent)
  },
  {
    path: 'solutions',
    loadComponent: () => import('./solutions/solutions.component').then(m => m.SolutionsComponent)
  },
  {
    path: 'cost-viewer',
    loadComponent: () => import('./cost-viewer/cost-viewer.component').then(m => m.CostViewerComponent)
  },
  {
    path: 'dashboard-serie',
    loadComponent: () => import('./dashboard-serie/dashboard-serie.component').then(m => m.DashboardSerieComponent)
  },
  {
    path: 'dashboard-program',
    loadComponent: () => import('./dashboard-program/dashboard-program.component').then(m => m.DashboardProgramComponent)
  },
  {
    path: 'ebom-manager',
    loadComponent: () => import('./ebom-manager/ebom-manager.component').then(m => m.EbomManagerComponent)
  },
  {
    path: 'octoplus-impulse',
    loadComponent: () => import('./octoplus-impulse/octoplus-impulse.component').then(m => m.OctoplusImpulseComponent)
  },
  {
    path: 'contact-us',
    loadComponent: () => import('./contact-us/contact-us.component').then(m => m.ContactUsComponent)
  },
  {
    path: 'privacy-policy',
    loadComponent: () => import('./privacy-policy/privacy-policy.component').then(m => m.PrivacyPolicyComponent)
  },
  {
    path: 'legal-information',
    loadComponent: () => import('./legal-information/legal-information.component').then(m => m.LegalInformationComponent)
  },
  {
    path: 'terms',
    loadComponent: () => import('./terms/terms.component').then(m => m.TermsComponent)
  },
  {
    path: '**',
    redirectTo: 'home',
    pathMatch: 'full',
  },
];
